'use client';
import Card, { CardContent } from '@/components/@base/card';
import Carousel, { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';

import { DATA_CY_ABOUT_COMPANIES } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

export default function Companies() {
  const companiesLogoArray = Object.keys(imagesList.icons.comapniesLogo);
  const {
    content: { aboutUs: aboutUsLocalization },
  } = pageLevelLocalization;

  return (
    <Container data-cy={DATA_CY_ABOUT_COMPANIES} className='relative my-12 max-w-[1279px] md:mx-auto *:w-full'>
      <Container className='mb-8 flex flex-col items-center justify-center'>
        <Text
          type={TEXT_TYPE.P}
          className='text-[26px] font-[200] leading-9 tracking-tighter text-[#424244]'
        >
          {aboutUsLocalization.who_from}
        </Text>
        <Text
          type={TEXT_TYPE.P}
          className='mt-1 text-[26px] font-medium leading-9 tracking-tighter text-[#424244]'
        >
          {aboutUsLocalization.zhaket_services_used}
        </Text>
      </Container>
      <Card noBorder className=''>
        <CardContent className='mx-auto w-full p-4 md:w-[72%] md:p-0'>
          <Carousel
            spaceBetween={50}
            center
            autoplay
            slidesPerView={3}
            breakpoints={{
              768: {
                slidesPerView: 5,
                spaceBetween: 80,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 80,
              },
            }}
          >
            {companiesLogoArray.map((company, index) => (
              <CarouselItem>
                <Container className='flex h-[100px] flex-1 items-center md:justify-end'>
                  <XImage
                    key={index}
                    src={imagesList.icons.comapniesLogo[company]}
                    alt={company}
                    width={80}
                    height={80}
                  />
                </Container>
              </CarouselItem>
            ))}
          </Carousel>
        </CardContent>
      </Card>
    </Container>
  );
}
